import * as React from 'react'
import { Button, CircularProgress, Tooltip, Zoom } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import { useAuth } from '../provider/AuthProvider'

interface LogoutComponentProps {
  paddingTop: number
}

const LogoutComponent: React.FC<LogoutComponentProps> = ({ paddingTop }: LogoutComponentProps) => {
  const { authenticated, onLogout, logoutLoading } = useAuth()

  return (
    <>
      { authenticated && (
        <Button color="inherit"
                sx={{ minWidth: 0, pt: paddingTop }}
                onClick={async () => { await onLogout() }}>
          <Tooltip title="Sign out" TransitionComponent={Zoom} arrow placement={'bottom'}>
            <LogoutIcon/>
          </Tooltip>
        </Button>
      )}
       {logoutLoading() && <CircularProgress size={22} sx={{ mb: 2 }}/>}
    </>
  )
}

export default LogoutComponent
